// eslint-disable-next-line import/prefer-default-export
export const weaponReskins = {
  // reskin: original,
  45: 40,
  46: 41,
  215: 210,
  1015: 1010,
  1115: 1110,
  2015: 2010,
  3005: 3000,
  4015: 4010,
  5015: 5010,
  6005: 6000,
};
